import { SelectSingleWebElementBase } from './SelectSingleWebElementBase';

/**
 * The component WebElement for [oj-c-select-single](../../jsdocs/oj-c.SelectSingle.html).
 * Do not instantiate this class directly, instead, use
 * [findSelectSingle](../functions/findSelectSingle.html).
 */
export class SelectSingleWebElement extends SelectSingleWebElementBase {
  // Put overrides here

  /**
   * Sets the value of the <code>value</code> property.
   * The value of the component.
   * @param value The value to set for <code>value</code>
   * @override
   */
  async changeValue<V extends string | number>(value: V | null) {
    // Only mutate if not readonly/disabled
    const readonly = await this.getReadonly();
    const disabled = await this.getDisabled();
    if (!(readonly || disabled)) {
      await this.getDriver().executeScript((element: HTMLElement) => element.focus(), this);
      await this.whenBusyContextReady();
      await this.getDriver().executeScript(
        (element: any, value: V | null) => {
          return element._selectItemByValue(value);
        },
        this,
        value
      );
    }
  }

  /**
   * Clears the value of the component.
   * @override
   */
  clear(): Promise<void> {
    return this.changeValue(null);
  }

  /**
   * Triggers the <code>ojAddToListAction</code> event.
   * @param searchText The <code>searchText</code> to include in the
   * <code>ojAddToListAction</code> event.
   */
  async doAddToListAction(searchText: string) {
    // Only fire event if add to list is on and component is not readonly/disabled
    const readonly = await this.getReadonly();
    const disabled = await this.getDisabled();
    const addToList = await this.getAddToList();
    if (!(readonly || disabled) && addToList === 'on') {
      await this.getDriver().executeScript('arguments[0].focus()', this);
      await this.whenBusyContextReady();
      await this.getDriver().executeAsyncScript(
        (element: any, searchText: string) => {
          return element._doAddToListAction(searchText);
        },
        this,
        searchText
      );
    }
  }

  /**
   * Triggers the <code>ojAdvancedSearchAction</code> event.
   * @param searchText The <code>searchText</code> to include in the
   * <code>ojAdvancedSearchAction</code> event.
   */
  async doAdvancedSearchAction(searchText: string) {
    // Only fire event if advanced search is on and component is not readonly/disabled
    const readonly = await this.getReadonly();
    const disabled = await this.getDisabled();
    const advancedSearch = await this.getAdvancedSearch();
    if (!(readonly || disabled) && advancedSearch === 'on') {
      await this.getDriver().executeScript((element: HTMLElement) => element.focus(), this);
      await this.whenBusyContextReady();
      await this.getDriver().executeScript(
        (element: any, searchText: string) => {
          return element._doAdvancedSearchAction(searchText);
        },
        this,
        searchText
      );
    }
  }
}
